import { Action, AnyAction } from "redux";
import { AppActionKey } from "../actions/ActionKeys";
import { AppState } from "../types";
import { FrameState } from "../types/FrameState";
import { app } from "./app";
import { frame } from "./frame";

/** The root reducer for the app. */
export const rootReducer: typeof app = <T extends Action = AnyAction>(
  state: AppState | undefined,
  action: T
) => app(action.type === AppActionKey.RESET ? undefined : state, action);

/** The root reducer for the frame. */
export const frameRootReducer: typeof frame = <T extends Action = AnyAction>(
  state: FrameState | undefined,
  action: T
) => frame(action.type === AppActionKey.RESET ? undefined : state, action);
